import { render, staticRenderFns } from "./RecursosCiclo.vue?vue&type=template&id=1dd94bc5&scoped=true"
import script from "./RecursosCiclo.vue?vue&type=script&lang=js"
export * from "./RecursosCiclo.vue?vue&type=script&lang=js"
import style0 from "./RecursosCiclo.vue?vue&type=style&index=0&id=1dd94bc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd94bc5",
  null
  
)

export default component.exports